<template>
  <div style="height: 32rem" class="flex items-center">
    <div class="shadow-lg mt-3 ml-3 p-6 bg-gray-50 w-1/4 h-full">
      <div
        @click="doScan"
        class="
          select-none
          shadow-lg
          bg-yellow-500
          text-white
          rounded-lg
          h-16
          w-44
          flex
          items-center
          justify-center
          cursor-pointer
          active:bg-yellow-700
        "
      >
        <i class="iconfont icon-saoma" style="font-size: 20pt"></i>
        <span class="text-lg pl-1">识别会员卡</span>
      </div>
      <el-divider></el-divider>

      <div v-if="card.card_id != '' && card.card_id != undefined">
        <p class="leading-none" style="margin-left: -0.5rem">
          <i
            class="iconfont icon-huiyuanqiagoumai"
            style="font-size: 50pt; color: #909090"
          ></i>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">卡号</span>
          <span class="pl-3 text-lg">{{ card.card_code }}</span>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">余额</span>
          <span class="pl-3 text-lg">{{ card.balance_amount }}</span>
          <span class="pl-1 text-xs">元</span>
        </p>
             <p class="mb-3">
          <span class="text-base text-gray-400">电子券</span>
          <span class="pl-3 text-lg">{{ card.balance_coupon }}</span>
          <span class="pl-1 text-xs">张</span>
        </p>
        <p class="mb-3">
              <span class="text-base text-gray-400">期限</span>
              <span class="pl-3 text-lg">{{ card.expiry_date }}</span>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">状态</span>
          <span class="pl-3 text-base">{{ card.state_name }}</span>
        </p>
        <p class="mb-3">
          <span class="text-base text-gray-400">类型</span>
          <span class="pl-3 text-base">{{ card.card_type_name }}</span>
        </p>

      </div>
      <div v-else>
        <el-empty :image-size="200" description="请先识别会员卡"></el-empty>
      </div>
    </div>
    <!--1-->

    <div class="shadow-lg pt-6 pl-6 mt-3 ml-3 mr-3 bg-gray-50 h-full w-2/4" v-if="card.card_id!='' && card.card_id!=undefined">

          <div>
              <p class=" text-gray-700 text-lg ">首次密码修改</p>
              <div class="mt-3">
                  <el-button type="primary" v-if="cardOverview.edit_pwd==1" @click="showEditPwdPage(0)">修改密码</el-button>
                  <template v-if="cardOverview.first_edit_pwd!=''">
                  <span class=" text-sm text-yellow-700">已修改</span><span class="pl-1 text-sm text-yellow-700">{{cardOverview.first_edit_pwd}}</span>
                  </template>
              </div>
          </div>
          <el-divider></el-divider>
          <div>
              <p class=" text-gray-700 text-lg ">密码重置申请</p>
              <div class="mt-3">
                  <el-button type="primary"  @click="showEditPwdPage(1)">点击申请</el-button>
                  <template v-if="cardOverview.last_reset_data!=''">
                    <div class="mt-3 ">
                    <span class="text-sm text-yellow-700">最近一次申请</span>
                    <span class="pl-1 text-sm text-yellow-700">{{cardOverview.last_reset_data}} <el-tag type="info" size="small">{{cardOverview.last_reset_state}}</el-tag></span>
                    </div>
                  </template>
              </div>
          </div>

    </div>
  </div>

  <ScanCard
    @receiveScanReslut="receiveScanReslutFun"
    @scanCardClose="scanCardCloseFun"
    :disScanTypeSwitch="true"
    :series="false"
    :fromw="fromw"
    :showView="showScanPage"
  >
  </ScanCard>

  <CardPwd
     title="请输入原密码"
    :showView="showPwdPage"
    @closeEvent="pwdCloseFun"
    @confirmEvent="pwdConfirmFun">

  </CardPwd>

  <el-dialog title="" v-model="dialogResultVisible" :before-close="handleClose" :show-close="false" >

 <el-result icon="success" :title="printResult.tips" subTitle="">

      <template #extra>

              <el-descriptions column="1">

                 <el-descriptions-item label="单号" >{{printResult.bill_id}}</el-descriptions-item>
                 <el-descriptions-item label="时间">{{printResult.oper_time}}</el-descriptions-item>

             <el-descriptions-item label="卡号">{{printResult.relate_id}}</el-descriptions-item>
                  <el-descriptions-item label="门店" >{{printResult.branch_name}}&nbsp;{{printResult.terminal_name}}</el-descriptions-item>

                  <el-descriptions-item label="收银">{{printResult.oper_user_name}}</el-descriptions-item>

              </el-descriptions>

             <el-button type="info" size="medium" @click="printAgain">补打单据</el-button>
        <el-button type="primary" size="medium" @click="dialogResultVisible=false">返回</el-button>
      </template>
    </el-result>

</el-dialog>

  <el-dialog title="设置密码" v-model="dialogEditPwdVisible" :before-close="handleClose" :show-close="false"    width="340px">

                 <p class=" text-yellow-700 text-lg "> 请让客户按密码器输入</p>

                 <div class="mt-6 w-72">
                     <p  class=" text-lg text-gray-500">新密码</p>

               <el-input class="mt-2 " name="new_pwd" type="password" v-model.lazy.trim="new_pwd" @keyup.enter="gotoNext('new_pwd_confirm')" placeholder="请按密码器输入新密码" clearable maxlength="10" />

                </div>

               <div class="mt-6  w-72">
                    <p  class=" text-lg text-gray-500">再次确认</p>
           <el-input class="mt-2 " name="new_pwd_confirm" type="password" v-model.lazy.trim="new_pwd_confirm" @keyup.enter="gotoNext('editPwdConfirmBtn')" placeholder="请按密码器再次输入新密码" clearable maxlength="10" />

                </div>

    <template #footer>
      <span class="dialog-footer">
          <el-button @click="editPwdConfirm" type="primary" name="editPwdConfirmBtn" >确 定</el-button>
        <el-button @click="editPwdCancel">取 消</el-button>
      </span>
    </template>

  </el-dialog>

</template>
<script>
import { reactive, ref, toRefs, watch } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import ScanCard from '../components/scanCard/index.vue'
import { getCardOverview, editPwdCard, resetPwdCard } from '../utils/member.js'
import CardPwd from '../components/cardPwd/index.vue'
import { noticePrint } from '@/utils/pos.js'
export default {
  components: { ScanCard, CardPwd },
  setup () {
    const fromw = 5

    const resultField = reactive({
      dialogResultVisible: false,
      printResult: {},
      printAgain: () => {
        noticePrint(resultField.printResult.print_id, () => {
          ElMessage({
            showClose: true,
            message: '打印请求成功',
            type: 'success'
          })
        })
      }
    })

    const cardOverview = ref({})
    const getCardOverviewFun = () => {
      getCardOverview({
        key_val: scanField.card.card_id
      }, (res) => {
        cardOverview.value = res
      })
    }

    /* 扫码的 */
    const scanField = reactive({
      card: {},
      showScanPage: false,
      receiveScanReslutFun: (cardParam) => {
        scanField.card = cardParam
        getCardOverviewFun()
      },
      scanCardCloseFun: () => {
        scanField.showScanPage = false
      },

      doScan: () => {
        if (
          scanField.card.card_id != '' &&
          scanField.card.card_id != undefined
        ) {
          ElMessageBox.confirm('本地已有会员卡信息，是否清空?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            scanField.card = {}
            scanField.showScanPage = true
          })
        } else {
          scanField.showScanPage = true
        }
      }
    })

    const editPwdField = reactive({
      dialogEditPwdVisible: false,
      new_pwd: '',
      new_pwd_confirm: '',
      flag: 0,
      gotoNext: (keyname) => {
        document.getElementsByName(keyname)[0].focus()
      },
      showEditPwdPage: (_flag) => {
        editPwdField.flag = _flag
        editPwdField.new_pwd = ''
        editPwdField.new_pwd_confirm = ''
        editPwdField.dialogEditPwdVisible = true
      },
      editPwdConfirm: () => {
        if (editPwdField.new_pwd.trim() == '') {
          ElMessage({
            showClose: true,
            message: '请输入新密码',
            type: 'error'
          })
          document.getElementsByName('new_pwd')[0].focus()
          return
        }
        if (editPwdField.new_pwd_confirm.trim() == '') {
          ElMessage({
            showClose: true,
            message: '请再次输入新密码',
            type: 'error'
          })
          document.getElementsByName('new_pwd_confirm')[0].focus()
          return
        }
        if (editPwdField.new_pwd.trim() != editPwdField.new_pwd_confirm.trim()) {
          ElMessage({
            showClose: true,
            message: '两次输入的密码不一致',
            type: 'error'
          })
          document.getElementsByName('new_pwd')[0].focus()
          return
        }
        editPwdField.dialogEditPwdVisible = false
        if (editPwdField.flag == 0) {
          pwdField.showPwdPage = true
        } else {
          resetPwdCard({
            new_pwd: editPwdField.new_pwd,
            card_id: scanField.card.card_id
          }, res => {
            scanField.card = {}
            resultField.printResult = res
            resultField.dialogResultVisible = true
          })
        }
      },
      editPwdCancel: () => {
        editPwdField.dialogEditPwdVisible = false
      }
    })

    watch(
      () => editPwdField.dialogEditPwdVisible,
      (newVal, oldVal) => {
        if (newVal) {
          setTimeout(() => {
            document.getElementsByName('new_pwd')[0].focus()
          }, 100)
        }
      }
    )

    const pwdField = reactive({
      showPwdPage: false,
      pwdCloseFun: () => {
        pwdField.showPwdPage = false
      },
      pwdConfirmFun: (val) => {
        pwdField.showPwdPage = false
        editPwdCard({
          old_pwd: val,
          new_pwd: editPwdField.new_pwd,
          card_id: scanField.card.card_id
        }, (res) => {
          scanField.card = {}
          resultField.printResult = res
          resultField.dialogResultVisible = true
        })
      }

    })
    const handleClose = () => {}

    return {
      handleClose,
      fromw,
      cardOverview,
      ...toRefs(resultField),
      ...toRefs(scanField),
      ...toRefs(pwdField),
      ...toRefs(editPwdField)
    }
  }
}
</script>
<style scoped>
</style>
